 import {PhoneRepository} from '../../../repositories/phone.repository';
 import {ErrorInformation} from '../../../core/services/errorRedirectService/errorInformation.model';
 import {IErrorRedirectService} from '../../../core/services/errorRedirectService/errorRedirect.service';
 import {IPhone, Phone} from '../../../models/Phone.model';

 export class PhoneGateway {

     public static $inject = ['$q', 'phoneRepository', 'errorRedirectService'];

     public constructor(private $q: ng.IQService,
         private phoneRepository: PhoneRepository,
         private errorRedirectService: IErrorRedirectService) {
     }

     public loadPhone(userId: string): ng.IPromise<IPhone> {
         return this.phoneRepository.getPhoneNumberByUserId(userId)
             .then((phone: IPhone) => {
                 if (!phone) {
                     phone = new Phone();
                     phone.userId = userId;
                     phone.phoneNumber = "";
                 }
                 return phone;
             })
             .catch((reason: string) => {
                 const error = new ErrorInformation();
                 error.errorMessage = reason;
                 error.errorDetails = reason;
                 this.errorRedirectService.redirectToErrorState(error);
                 return new Phone;
             });
     }

     public savePhone = (phone: IPhone): ng.IPromise<IPhone> => {
         const phonePromise: ng.IPromise<IPhone> = phone.id != null
             ? this.phoneRepository.put(phone)
             : this.phoneRepository.post(phone);

         return phonePromise.then((phone: IPhone) => {
             return phone;
         });
     }
 }